export const keywordVariants = {
    initial: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)"
    }, animate: (i)=> ({
        opacity: 1,
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 1,
            delay: 0.2 + 0.05*i,
            ease: "easeIn"
        }
    }), exit: {
        opacity: 0,
        transform: "translate3d(0, 100%, 0)"
    }
}

export const metaVariants = {
    initial: {
        opacity: 0
    }, animate: {
        opacity: 1,
        transition: {
            duration: 0.75,
            ease: "easeIn"
        }
    }, exit: {
        opacity: 0
    }
}